import type { StackProps } from '@mui/material';
import { Stack } from '@mui/material';

/**
 * 가로 전용 Stack. (flex-direction: row)
 *
 * ```tsx
 * <HStack spacing={1} alignItems="center">
 *   <Typography>아이템1</Typography>
 *   <Typography>아이템2</Typography>
 * </HStack>
 * ```
 */
export const HStack = (props: Omit<StackProps, 'direction'>) => {
  return <Stack {...props} direction={'row'} />;
};

/**
 * 세로 전용 Stack. (flex-direction: column)
 *
 * ```tsx
 * <VStack spacing={1}>
 *   <Typography>아이템1</Typography>
 *   <Typography>아이템2</Typography>
 * </VStack>
 * ```
 */
export const VStack = (props: Omit<StackProps, 'direction'>) => {
  return <Stack {...props} direction={'column'} />;
};
